import { ATHLETES_VISIBILITY_TYPES } from '@strava/constants/src/athletesVisibilityConstants';

export const getProfileVisibility = (athlete) => {
  return athlete.profileVisibility === ATHLETES_VISIBILITY_TYPES.followers
    ? ATHLETES_VISIBILITY_TYPES.followers
    : ATHLETES_VISIBILITY_TYPES.everyone;
};

export default getProfileVisibility;
